module.exports = __webpack_public_path__ + "img/lg_ring_g_i_0_null@2x.0519dcaa.png";